import React, {
  Component,
  PropTypes,
} from 'react';
import { compose } from 'recompose';
import { routesByValue } from 'helpers/routesConstant';
import { withRouter } from 'react-router';
import HeaderContent from 'components/headers/HeaderContent';
import CustomTabs from 'components/Tabs/CustomTabs';
import muiThemeable from 'material-ui/styles/muiThemeable';
import Sticky from 'components/Sticky'

class Banners extends Component {
  render() {
    const { router, location: { pathname }, muiTheme: { palette } } = this.props;
    const createDefaultValue = () => {
      if (pathname === routesByValue.banners.value) {
        return routesByValue.banners.value
      } else if (pathname.includes(routesByValue.categoryBanner.value)) {
        return routesByValue.categoryBanner.value
      } else if (pathname.includes(routesByValue.tagBanner.value)) {
        return routesByValue.tagBanner.value
      }
      return ''
    }
    return (
      <div>
        <Sticky>
          <HeaderContent label={routesByValue.banners.label} />
          {pathname.includes(routesByValue.banners.value) &&
          <div style={{ backgroundColor: palette.primary1Color }}>
            <CustomTabs
              defaultTabValue={createDefaultValue(pathname)}
              onTouchTab={(value) => router.push(value)}
            >
              <CustomTabs.Tab
                tabValue={routesByValue.banners.value}
                tabLabel="Global"
                primary
                size="medium"
                borderStyle={{ borderBottom: `3px solid ${palette.accent1Color}` }}
              />
              <CustomTabs.Tab
                tabValue={routesByValue.categoryBanner.value}
                tabLabel="Category"
                primary
                size="medium"
                borderStyle={{ borderBottom: `3px solid ${palette.accent1Color}` }}
              />
              <CustomTabs.Tab
                tabValue={routesByValue.tagBanner.value}
                tabLabel="Tags"
                primary
                size="medium"
                borderStyle={{ borderBottom: `3px solid ${palette.accent1Color}` }}
              />
            </CustomTabs>
          </div>
          }
        </Sticky>
        {this.props.children}
      </div>
    );
  }
}

Banners.propTypes = {};
Banners.defaultProps = {};

export default compose(withRouter, muiThemeable())(Banners);




// WEBPACK FOOTER //
// ./src/pages/Banners/index.js